import React from 'react';

export interface IPagination {
  readonly current: number; // 当前页数
  readonly total: number; // 数据总数
  readonly defaultCurrent?: number; // 默认的当前页数，默认值 1
  readonly defaultPageSize?: number; // 默认的每页条数，默认值 10
  readonly pageSize?: number; // 每页条数
  readonly onChange?: (page: number, pageSize: number) => void; // 页码改变的回调，参数是改变后的页码及每页条数
  readonly position?: PaginationPosition; // 默认 bottomRight

  // 用于显示数据总量和当前数据顺序
  readonly showTotal?:
    | true
    | ((total: number, pagination: IPagination) => React.ReactNode | string)
    | null;
}

// 分页位置
export enum PaginationPosition {
  bottomLeft,
  bottomCenter,
  bottomRight,
}
